import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { legacy_createStore as createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import "semantic-ui-css/semantic.min.css";
import App from "./App";
import rootReducer from "./bundles/common/reducers";
import rootSaga from "./bundles/common/saga/index";

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(rootSaga);

// PWA Service Worker 등록 (public/service-worker.js).
// 정적 자원 캐시 + 푸시 알림 수신. localhost / https 환경에서만 등록됨 (브라우저 정책).
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch(err => {
        // 등록 실패해도 앱은 그대로 동작 — 단지 PWA 기능만 비활성.
        // eslint-disable-next-line no-console
        console.warn("Service Worker 등록 실패:", err);
      });
  });
}

const root = createRoot(document.querySelector("#root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
